import { Drawer } from "../../ui/Drawer";
import { useBrandAuthoring } from "../scan/useBrandAuthoring";
import { TovAuthoringPanel } from "../tov/TovAuthoringPanel";
import { invalidateWorkspaces } from "./playgroundQueries";
import { VoiceImportPicker } from "./VoiceImportPicker";

/**
 * In-place Tone of Voice authoring for a playground workspace: author a voice
 * from scratch, or import a real client's processed voice — all over the
 * current screen, no route change. A workspace is a Client, so it reuses the
 * same clientId-scoped authoring surface as the Signal Scan manage page.
 */
export function VoiceDrawer(props: {
  clientId: string;
  clientName: string;
  onClose: () => void;
}) {
  const authoring = useBrandAuthoring({
    clientId: () => props.clientId,
    clientName: () => props.clientName,
  });

  const close = () => {
    // The workspace badge ("brand voice active") reads the pinned version; a
    // refetch reflects any author/import that happened while the drawer was open.
    void invalidateWorkspaces();
    props.onClose();
  };

  return (
    <Drawer title="Brand voice" onClose={close} wide>
      <VoiceImportPicker
        clientId={props.clientId}
        onImported={(version) => {
          authoring.setProfileId(version.profileId);
          authoring.setVersionId(version.id);
          authoring.seedVersion(version);
          void authoring.invalidateTov();
        }}
      />
      <TovAuthoringPanel authoring={authoring} />
    </Drawer>
  );
}
